import { DollarSign, ArrowRight } from "lucide-react";

const FeesTab = ({ setActiveTab }) => {
  return (
    <div className="space-y-6">
      <div className="bg-white border border-slate-200/60 rounded-2xl p-6">
        <div className="flex items-start justify-between mb-6">
          <div>
            <h3 className="text-lg font-semibold text-slate-900">Processing Fee Settings</h3>
            <p className="text-sm text-slate-500 mt-1">
              Configure how payment processing fees are handled for your organization
            </p>
          </div>
          <div className="w-12 h-12 bg-amber-100 rounded-2xl flex items-center justify-center">
            <DollarSign className="w-6 h-6 text-amber-600" />
          </div>
        </div>
        
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
          <p className="text-sm text-blue-800">
            Fee configuration has been moved to the <strong>Banking</strong> tab for easier management alongside your connected Stripe account.
          </p>
          {setActiveTab && (
            <button 
              onClick={() => setActiveTab("banking")}
              className="mt-2 text-sm text-blue-600 hover:text-blue-800 font-medium inline-flex items-center gap-1"
            >
              Go to Banking Settings
              <ArrowRight className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeesTab;
